"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRCode = void 0;
var _react = _interopRequireDefault(require("react"));
var _qrcode = _interopRequireDefault(require("qrcode.react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var QRCodeComponent = (0, _styledComponents.default)(_qrcode.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var $blurred = _ref.$blurred;
  return $blurred && 'cursor: pointer; -webkit-filter: blur(3px); -moz-filter: blur(3px); -ms-filter: blur(3px); -o-filter: blur(3px); filter: url("data:image/svg+xml;utf8,<svg height="0" xmlns="http://www.w3.org/2000/svg"><filter id="svgBlur" x="-5%" y="-5%" width="110%" height="110%"><feGaussianBlur in="SourceGraphic" stdDeviation="5"/></filter></svg>#svgBlur"); filter: progid: DXImageTransform.Microsoft.Blur(PixelRadius = "3"); filter: blur(3px);';
});
var QRCode = function QRCode(_ref2) {
  var value = _ref2.value,
    size = _ref2.size,
    onClick = _ref2.onClick,
    className = _ref2.className,
    $blurred = _ref2.$blurred;
  return /*#__PURE__*/_react.default.createElement(QRCodeComponent, {
    $blurred: $blurred,
    size: size,
    value: value,
    onClick: onClick,
    className: className
  });
};
exports.QRCode = QRCode;